import { Button, Container, Form, Spinner, Table } from "react-bootstrap";

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Income = () => {
  const [loading, setLoading] = useState(false);
  const [allIncome, setAllIncome] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [formData, setFormData] = useState({
    date: "",
    desc: "Miscellaneous",
    amount: 0,
  });
  const [showDeleted, setShowDeleted] = useState(false);

  useEffect(() => {
    const fetchIncome = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/income`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setAllIncome(response.data);
        const total = response.data.reduce((acc, item) => acc + item.amount, 0);
        setTotalIncome(total);
        setLoading(false);
      } catch (error) {
        setErrMsg(
          " Something not right! please contact us, and provid the following error message " +
            "'" +
            error.message +
            "'",
        );

        setLoading(false);
      }
    };
    fetchIncome();
  }, [refresh]);
  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/invoices?deleted=${showDeleted}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setInvoices(response.data);
        const total = response.data.reduce(
          (acc, item) =>
            !item.deletedAt ? acc + (Number(item.total) || 0) : acc,
          0,
        );
        setTotalInvoices(total);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    fetchInvoices();
  }, [refresh, showDeleted]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${process.env.REACT_APP_API_URL}/income/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setRefresh((prev) => !prev);
      setFormData({
        date: "",
        desc: "Miscellaneous",
        amount: 0,
      });
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    return (
      <Container
        style={{ height: "100vh", fontSize: "250px" }}
        className="d-flex justify-content-center align-items-center"
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }
  return (
    <Container style={{ paddingBottom: 100 }}>
      {/* <div
        style={{
          maxWidth: 600,
          justifyItems: "center",
          display: "flex",
          flexDirection: "column",
          marginBottom: 20,
        }}
      >
        <h1>Add new income</h1>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              name="desc"
              value={formData.desc}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="float"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Button className="mt-3" type="submit">
            Add Income
          </Button>
        </Form>
      </div> */}
      {/* <p>
        =====================================================================
      </p> */}
      <div className="row flex ">
        {/* <div className="col">
          <h1>Income</h1>
          <Table striped bordered hover className="overflow-auto">
            <thead>
              <tr>
                <th>Date</th>
                <th>Describtion</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {allIncome &&
                allIncome.map((income) => (
                  <tr key={income.id}>
                    <td>{new Date(income.date).toLocaleDateString("en-AU")}</td>
                    <td>{income.desc}</td>
                    <td>{income.amount}</td>
                  </tr>
                ))}
              <tr>
                <td></td>
                <td>
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>{totalIncome}</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div> */}
        <div className="col">
          <h1>Invoices list</h1>
          <Button
            variant="outline-secondary"
            className="mb-3"
            onClick={() => setShowDeleted(!showDeleted)}
          >
            {showDeleted ? "Hide Deleted" : "Show Deleted"}
          </Button>
          <Table striped bordered hover className="overflow-auto">
            <thead>
              <tr>
                <th>Number</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Value</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {invoices &&
                invoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>{invoice.invoiceNumber}</td>
                    <td>{invoice.Customer?.name}</td>
                    <td>
                      {new Date(invoice.date).toLocaleDateString("en-AU")}
                    </td>

                    <td>
                      {/* <Link to={`/invoice/${invoice.id}`}>
                        <button
                          className="btn btn-primary"
                          onClick={() => console.log(invoice)}
                        >
                          open invoice
                        </button>
                      </Link> */}
                      {invoice.total}
                    </td>
                    <td>
                      <strong>
                        {invoice.deletedAt ? (
                          <span style={{ color: "red" }}>Deleted</span>
                        ) : (
                          <span style={{ color: "green" }}>Active</span>
                        )}
                      </strong>
                    </td>
                  </tr>
                ))}
              <tr>
                <td></td>
                <td></td>
                <td>
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>{totalInvoices}</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
};

export default Income;
